import { IMedList } from '../../types/type';
import './medlist.css';
import { formatBackendShortDate, formatBackendTime } from '../../utils/date.utils';
import Table, { LabeledCell, ColumnConfig, ExpandedRowConfig } from '../Table/Table';
import StatusCell from '../Table/StatusCell';

function MedList({ medlist }: { medlist: IMedList }) {
  // Статус-маппинг для визуализации статусов
  const statusMap = {
    completed: { label: 'Осмотр пройден', dotClass: 'active' },
    rejected: { label: 'Осмотр не пройден', dotClass: '' },
    waiting: { label: 'Ожидает', dotClass: 'waiting' },
  };

  // Конфигурация колонок для таблицы
  const tableColumns: ColumnConfig[] = [
    {
      id: 'date',
      title: 'Дата',
      render: () => (
        <>
          <div className="table-cell-title">Дата</div>
          <div className="table-cell-value">{formatBackendShortDate(medlist.checkTime)}</div>
        </>
      ),
    },
    {
      id: 'num',
      title: 'Номер заявки',
      render: () => (
        <>
          <div className="table-cell-title">Номер заявки</div>
          <div className="table-cell-value">{medlist.num || '-'}</div>
        </>
      ),
    },
    {
      id: 'time',
      title: 'Время',
      render: () => (
        <>
          <div className="table-cell-title">Время</div>
          <div className="table-cell-value">{formatBackendTime(medlist.checkTime)}</div>
        </>
      ),
    },
    {
      id: 'status',
      title: 'Статус',
      render: () => {
        const status =
          medlist.status === 'completed' ? 'completed' : medlist.status === 'rejected' ? 'rejected' : 'waiting';
        return <StatusCell status={status} statusMap={statusMap} />;
      },
      className: 'table-cell-centered',
    },
    {
      id: 'actions',
      title: 'Смотреть',
      render: () => null, // Рендеринг происходит внутри компонента Table
    },
  ];

  // Конфигурация расширяемых строк
  const expandedRows: ExpandedRowConfig[] = [
    {
      id: 'parameters',
      content: () => (
        <>
          <LabeledCell title="Температура" value={medlist.bodyTemperature} />
          <LabeledCell title="Давление" value={medlist.bloodPressure} />
          <LabeledCell title="Пульс" value={medlist.heartRate} colSpan={2} />
        </>
      ),
    },
    {
      id: 'conclusion',
      content: () => (
        <>
          <LabeledCell title="Алкотестер" value={medlist.bloodAlcohol} />
          <LabeledCell title="Жалобы" value={medlist.symptomsPresent ? 'Есть' : 'Нет'} />
          <LabeledCell
            title="Заключение"
            value={
              medlist.status === 'completed' ? 'Пройдено' : medlist.status === 'rejected' ? 'Не пройдено' : 'Ожидает'
            }
            colSpan={2}
          />
        </>
      ),
    },
  ];

  // Создаем массив из одного элемента для компонента Table
  const medListArray = [medlist];

  return (
    <div className="medlist-container">
      <Table
        data={medListArray}
        columns={tableColumns}
        expandedRows={expandedRows}
        keyField="id"
        className="medlist-table"
        rowClassName="medlist-row"
      />
    </div>
  );
}

export default MedList;
